import { Toggle } from '@warp-ds/react/components/toggle';
import { destinations, type PopularDestination } from './destinationFilterData';

type DestinationFilterProps = {
    currentDestinationLabel: string | undefined;
    onDestinationChange: (destination: PopularDestination) => void;
};

export const DestinationFilter = ({ currentDestinationLabel, onDestinationChange }: DestinationFilterProps) =>
    destinations.map((destination) => (
        <Toggle
            key={destination.value}
            label={destination.label}
            type="checkbox"
            checked={currentDestinationLabel === destination.label}
            onChange={() => onDestinationChange(destination)}
        />
    ));
